import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { warningColor } from './status/warning';

export const warning = (mode: PaletteMode, opts: GetThemeOptions): SimplePaletteColorOptions => {
  const color = warningColor(mode, opts);

  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
